import React from 'react';
import { CONFIG } from '../utils/config';
import { authService } from '../utils/authServices';

const DropDownMenu: React.FC = () => {
   // Get the user data from authService
   const userInfo = authService.getUserInfo();
    
   
    // Access name and email, providing fallback values if userInfo is null
    const userName = userInfo?.name || '';
    const userEmail = userInfo?.email || '';

    return (
       <div className="dropdown">
            <a href="#" className="dropdown-toggle text-decoration-none mobmenu" id="dropdownProfileMenu" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="bi bi-person-circle" style={{ fontSize: '1.5rem' }}></i>
            </a>
            <ul className="dropdown-menu dropdown-menu-end userflymenu" aria-labelledby="dropdownProfileMenu">
                <li className="p-3 border-bottom">
                    <span className="fw-bold">{userName}</span><br />
                    <span className="text-muted small">{userEmail}</span>
                </li>
                <li><a className="dropdown-item" href={CONFIG.urls.getProfileUrl()}>Προφίλ</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item text-danger" href={CONFIG.urls.getLogoutUrl()}>Αποσύνδεση</a></li>
            </ul>
        </div>
    );
};

export default DropDownMenu;
